import { useQuery } from 'react-query';
import { getRoles } from '../services/roles-api.service';

export default function useRoles() {
  return useQuery(['roles'], () => getRoles().then(({ data }) => data), {
    refetchOnWindowFocus: false
  });
}
